import {Button, Card, Space, Typography} from 'antd';
import {LinkOutlined} from '@ant-design/icons';

const {Text} = Typography;

const MainDashboardIndex = () => {
  return (
    <Space direction={'horizontal'}>
      <Card>
        <Space direction={'horizontal'}>
          <LinkOutlined />
          <Button
            type={'link'}
            href={'https://www.gyri.tech/'}
            block
            target={'_blank'}
          >
            <Text>
              Visit website
            </Text>
          </Button>
        </Space>
      </Card>
    </Space>
  );
};

export default MainDashboardIndex;
